module.exports = __webpack_public_path__ + "img/workspace-onboarding/edit-together-5bb181d2b70e3a3ad041930aa8cb7b9c.png";